/**
 * @file SetHomeHost.tsx
 * @description Окно «Сделать главной» в конструкторе (phase19.16 Р2): берёт
 * страницу и текущую главную из списка страниц, после смены перечитывает
 * список, открытую страницу, сводки черновика и канву (Р3а).
 */

import { useNotify } from "../../ui/NotifyProvider";
import { useBuilder } from "../builder-context";
import { SetHomePageDialog } from "./SetHomePageDialog";

export function SetHomeHost({ pageId, onClose }: { pageId: string | null; onClose: () => void }) {
  const b = useBuilder();
  const notify = useNotify();
  const list = b.pages.list ?? [];
  const page = pageId ? (list.find((p) => p.id === pageId) ?? (b.pages.page?.id === pageId ? b.pages.page : null)) : null;
  const home = list.find((p) => p.kind === "SYSTEM_HOME" && p.id !== pageId) ?? null;

  return (
    <SetHomePageDialog
      open={pageId !== null}
      page={page}
      home={home}
      canPublish={b.canPublishPages}
      onClose={onClose}
      onDone={async (result) => {
        // Р3а: обе страницы получили новые версии — перечитать страницу, список, сводки и канву.
        await b.publishing.afterChange();
        notify.success(`«${result.home.title}» — теперь главная страница${result.previous ? `, «${result.previous.title}» осталась обычной страницей` : ""}`);
      }}
    />
  );
}
